<template>
  <v-card :disabled="disabled">
    <v-skeleton-loader
      v-if="loading"
      :type="horizontal ? 'list-item-avatar' : 'list-item-avatar@3'"
      elevation="0"
    >
    </v-skeleton-loader>
    <v-card-text v-else class="py-1">
      <v-row>
        <v-col cols="auto" class="pl-8 my-auto">
          <template v-if="disabled || !completion">
            <div class="font-weight-medium">
              Total Participation Rate
            </div>
            <div>
              No Data
            </div>
          </template>
          <engagement-text
            v-else
            :engagement="overview.overallUserRecords"
            title="Total Participation Rate"
          >
          </engagement-text>
        </v-col>
        <v-spacer></v-spacer>
        <v-col
          cols="auto"
          class="py-0 my-auto text-right pr-8"
          v-if="overview.userRecords && overview.userRecords.length > 0"
        >
          <div>
            <v-btn text color="info" @click="showRecipients">
              View recipients >
            </v-btn>
          </div>
          <overlap-avatars
            :users="overview.userRecords.map(x => x.user)"
            v-on:click="showRecipients"
            class="cursor-pointer"
          ></overlap-avatars>
        </v-col>
      </v-row>
    </v-card-text>
    <engagement-card-recipients-dialog
      ref="recipients"
      :isResources="isResources"
      :overview="overview"
      v-on:click="$emit('click', $event)"
    ></engagement-card-recipients-dialog>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import EngagementText from "@/components/reporting/EngagementText";
import EngagementCardRecipientsDialog from "@/components/reporting/EngagementCardRecipientsDialog";
import OverlapAvatars from "@/components/common/OverlapAvatars";
export default {
  name: "EngagementCard",
  components: {
    EngagementText,
    EngagementCardRecipientsDialog,
    OverlapAvatars
  },
  props: {
    data: { type: String, default: "survey/edit_survey" },
    horizontal: { type: Boolean, default: false },
    uniqueTitle: { type: String, default: "Unique Sends" },
    showUnique: { type: Boolean, default: false },
    isResources: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data: () => ({}),
  computed: {
    iconColor() {
      return this.disabled
        ? this.$vuetify.theme.themes.light.lighttext
        : this.$vuetify.theme.themes.light.secondarytext;
    },
    iconColorBackground() {
      return this.getColor(this.iconColor, 0.1);
    },
    cols() {
      return this.horizontal ? "auto" : 12;
    },
    getColorBackground() {
      return color => {
        return this.getColor(color, 0.2);
      };
    },
    completion() {
      if (
        this.overview.overallUserRecords &&
        this.overview.overallUserRecords.completion
      ) {
        return this.$coreScores.reverseFormat(
          this.overview.overallUserRecords.completion
        );
      }
      return 0;
    },
    overview() {
      return this.$store.getters[this.data];
    },
    uniqueSends() {
      if (this.isResources) {
        return Object.keys(this._.countBy(this.sent_resources, "id")).length;
      }
      return Object.keys(this._.countBy(this.sent_surveys, "surveyId")).length;
    },
    ...mapGetters({
      sent_surveys: "reporting/sent_surveys",
      sent_resources: "reporting/sent_resources"
    })
  },
  created() {},
  mounted() {
    if (this.$route.query.showRecipients) {
      this.showRecipients();
    }
  },
  methods: {
    showRecipients() {
      this.$refs.recipients.showDialog();
    }
  }
};
</script>
